export const TIMEZONE = 'Asia/Seoul';

export const BRAND_PREFIX = '[모당]';

export const SLOT_MINUTES_OPTIONS = [30, 45, 60, 90, 120] as const;
export type SlotMinutes = (typeof SLOT_MINUTES_OPTIONS)[number];

export const BOOKING_HOLD_MINUTES = {
  toss_pay: 10,
  virtual_account_hours: 24,
} as const;

export const CANCEL_CUTOFF_DAYS = 3;

export const SUBSCRIPTION_DEFAULTS = {
  monthly_price_krw: 33000,
  grace_days: 3,
  retry_schedule: [1, 3, 5] as number[],
};
